<app-header-one [class]="'header-gym'"></app-header-one>
<!-- <app-separator  [size]="'lg'"></app-separator> -->
<!--section class="p-0 gym-slider">
    <ng-container *ngIf="cartData && cartData.order">
        <h1>Il mio ordine<br><small *ngIf="cartData.count > 0">{{cartData.order.euro_total.toFixed(2)}} &euro;</small></h1>
        <div class="container border-0 text-center">
            <div class="row mx-auto">
                <div class="col-6 pl-0 my-1">
                    <h4 class="mb-1 text-center">Orario</h4>                       
                    <p class="pt-1 mb-0 c-pointer" *ngIf="cartData.order.tipomodoconsegna == tipoConsegna.PRENOTAZIONE">Per il {{cartData.order.data_ordine_dmy}}</p>
                    <p class="pt-1 c-pointer" style="font-size: 16px;" [ngSwitch]="cartData.order.tipooraconsegna">
                        <ng-container *ngSwitchCase="tipoOra.ORARIO">
                            <span *ngIf="cartData.order.order_date == 'FAST'">Appena possibile</span>
                            <span *ngIf="cartData.order.order_date != 'FAST' && cartData.order.order_date != -2">
                                <ng-container *ngIf="cartData.order.tipomodoconsegna == tipoConsegna.PRENOTAZIONE">alle </ng-container>{{cartData.order.order_date}}
                            </span>
                            <span *ngIf="cartData.order.order_date == -2">Non disponibile ora</span>
                        </ng-container>
                        <ng-container *ngSwitchCase="tipoOra.FASCIAORARIA">
                            <span *ngIf="cartData.order.fasciaoraria != -2">Tra le {{cartData.order.fasciaoraria}}</span>
                            <span *ngIf="cartData.order.fasciaoraria == -2">Non disponibile ora</span>
                        </ng-container>
                    </p> 
                    <a (click)="editOrderTime()">Modifica</a>                   
                </div>
                <div class="col-6 pl-0 my-1">
                    <h4 class="mb-1 text-center">Coupon</h4>   
                    <p class="pt-1" style="font-size: 16px;">Hai un codice sconto?</p>     
                    <a (click)="opencouponmodal()">Inserisci</a>
                </div>
            </div>
        </div>
    </ng-container>
</section-->

<section class="section-b-space cart-page pt-0">
    <div class="container">
        <div class="row">
            <div class="col-xl-3 col-lg-3 col-md-3">
                <h2 class="my-5 d-none d-md-block">Il tuo ordine</h2>
                <div class="mt-4 d-block d-md-none"><app-navigation-bar [page]="'Carrello'"></app-navigation-bar></div>
            </div>
            <div class="col-xl-9 col-lg-9 col-md-9" *ngIf="cartData && cartData.count==0">
                <h3 class="py-5 my-5">Il carrello è vuoto!</h3>
                <a class="button-primary-text button-fill-rounded mb-5" href="/bloomtasty/">
                  Torna alla Home
                  <img src="assets/icons/freccia.svg">
                </a>
            </div>
            <div class="col-xl-9 col-lg-9 col-md-9 mt-5 d-none d-md-block" *ngIf="cartData && cartData.count>0">
                <div class="row mt-5">
                    <div class="col-xl-6 col-sm-12 col-12">
                        <div class="big-cart-box">
                            <div class="checkout-title m-0 d-sm-block">
                                <h3>Cassa</h3>
                            </div>
                            <!-- <ng-container *ngIf="cartData && cartData.order && cartData.order.items && (cartData.order.items | array).length > 0 && restaurant.has_promo && calcPercPromo() < 100">
                              <h3 *ngIf="restaurant.has_free_delivery"> 
                                Ti mancano {{(getPromoFDOM(restaurant) - cartData.order.euro_total).toFixed(2)}} &euro; per la consegna gratuita
                              </h3>
                              <h3 *ngIf="restaurant.has_promo && !restaurant.has_free_delivery && cartData.order.euro_promo<0.01 && promoEuroMin()>0.01"> 
                                Ti mancano {{(restaurant.promos[0][0].order_min - cartData.order.euro_total).toFixed(2)}} &euro; per {{restaurant.promos[0][0].text_short}}
                              </h3>
                              <div class="progress">
                                <div class="progress-bar w-{{calcPercPromo()}}" role="progressbar" aria-label="Basic example" aria-valuenow="calcPercPromo()" aria-valuemin="0" aria-valuemax="100"></div>
                              </div>
                            </ng-container> -->
                            <h4 *ngIf="cartData.order.items && (cartData.order.items | array).length > 0"
                                class="mt-3 title title-lime text-start">
                                Ordine da {{cartData.order.restaurant}}
                            </h4>
                            <div class="checkout-form py-3"
                                *ngIf="cartData.order.items && (cartData.order.items | array).length > 0">
                                <table>
                                    <thead>
                                        <th>PRODOTTO</th>
                                        <th class="text-center" style="width: 150px;">PREZZO</th>
                                        <th class="text-center">QUANTIT&Agrave;</th>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td colspan="3" class="p-0"><app-separator></app-separator></td>
                                        </tr>
                                        <ng-container *ngIf="cartData.order && cartData.order.items">
                                            <ng-container *ngFor="let elCartArray of (cartData.order.items | array)">

                                                <ng-container *ngFor="let elCart of elCartArray">
                                                    <tr>
                                                        <td>
                                                            {{ elCart.name }}
                                                            <p> <small>{{ shortDescr(elCart) }}</small>{{
                                                                longDescr(elCart) }}{{
                                                                ingredients(elCart) }}</p>
                                                            <p class="text-start"
                                                                *ngIf="elCart.details && elCart.details.length==0 && elCart.extradetails && elCart.extradetails.length==0 && elCart.subitems && elCart.subitems.length==0">
                                                                {{ elCart.descr }}
                                                            </p>
                                                            <p class="text-start" *ngFor="let detail of elCart.details">
                                                                + {{ detail.name }}
                                                            </p>
                                                            <p class="text-start"
                                                                *ngFor="let extradetail of elCart.extradetails">
                                                                + {{ extradetail.name }}
                                                            </p>
                                                            <ng-container *ngFor="let subitem of elCart.subitems">
                                                                <p class="text-start" *ngIf="subitem.name">+ {{
                                                                    subitem.name }}</p>
                                                                <ng-container *ngIf="!subitem.name">
                                                                    <p class="text-start" *ngFor="let subit of subitem">
                                                                        + {{ subit.name }}
                                                                    </p>
                                                                </ng-container>
                                                            </ng-container>
                                                        </td>
                                                        <td class="text-center" style="width: 150px;">{{
                                                            elCart.endprice.toFixed(2) }} &euro;</td>
                                                        <td class="text-center">
                                                            <div class="qty-box">
                                                                <div class="input-group">
                                                                    <span class="input-group-prepend">
                                                                        <button type="button" class="btn btn-minus"
                                                                            data-type="minus"
                                                                            (click)="removeToCartSingle(elCart)">
                                                                            <img src="assets/icons/meno.svg">
                                                                        </button>
                                                                    </span>
                                                                    <input type="text" name="quantity"
                                                                        class="form-control input-number quantity"
                                                                        [value]="elCart.qty" disabled>
                                                                    <span class="input-group-prepend">
                                                                        <button type="button" class="btn"
                                                                            data-type="plus"
                                                                            (click)="addToCartSingle(elCart)">
                                                                            <img src="assets/icons/aggiungi.svg">
                                                                        </button>
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </ng-container>
                                            </ng-container>
                                        </ng-container>
                                    </tbody>
                                </table>
                                <app-separator></app-separator>
                            </div>
                            <ng-container *ngIf="cartData && cartData.order && cartData.order.slaves">
                                <ng-container *ngFor="let slave of cartData.order.slaves;let s=index">
                                    <ng-container *ngIf="slave.items && (slave.items | array).length > 0">
                                        <h4 *ngIf="slave.items && (slave.items | array).length > 0"
                                            class="mt-3 title title-lime text-start">Ordine da {{slave.rest_name}}
                                        </h4>
                                        <div class="checkout-form py-3">
                                            <table>
                                                <thead>
                                                    <th>PRODOTTO</th>
                                                    <th class="text-center" style="width: 150px;">PREZZO</th>
                                                    <th class="text-center">QUANTIT&Agrave;</th>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td colspan="3" class="p-0"><app-separator></app-separator></td>
                                                    </tr>
                                                    <ng-container *ngFor="let elCartArray of (slave.items | array)">
                                                        <ng-container *ngFor="let elCart of elCartArray">
                                                            <tr>
                                                                <td>
                                                                    {{ elCart.name }}
                                                                    <p> <small>{{ shortDescr(elCart) }}</small>{{
                                                                        longDescr(elCart) }}{{ingredients(elCart) }}</p>
                                                                    <p class="text-start"
                                                                        *ngIf="elCart.details && elCart.details.length==0 && elCart.extradetails && elCart.extradetails.length==0 && elCart.subitems && elCart.subitems.length==0">
                                                                        {{ elCart.descr }}
                                                                    </p>
                                                                    <p class="text-start"
                                                                        *ngFor="let detail of elCart.details">
                                                                        {{ detail.name }}
                                                                    </p>
                                                                    <p class="text-start"
                                                                        *ngFor="let extradetail of elCart.extradetails">
                                                                        {{ extradetail.name }}
                                                                    </p>
                                                                    <ng-container
                                                                        *ngFor="let subitem of elCart.subitems">
                                                                        <p class="text-start" *ngIf="subitem.name">+ {{
                                                                            subitem.name }}</p>
                                                                        <ng-container *ngIf="!subitem.name">
                                                                            <p class="text-start"
                                                                                *ngFor="let subit of subitem">
                                                                                {{ subit.name }}
                                                                            </p>
                                                                        </ng-container>
                                                                    </ng-container>
                                                                </td>
                                                                <td class="text-center" style="width: 150px;">{{
                                                                    elCart.endprice.toFixed(2) }} &euro;</td>
                                                                <td class="text-center">
                                                                    <div class="qty-box">
                                                                        <div class="input-group">
                                                                            <span class="input-group-prepend">
                                                                                <button type="button"
                                                                                    class="btn btn-minus"
                                                                                    data-type="minus"
                                                                                    (click)="removeToCartSlave(elCart, slave.order_id)">
                                                                                    <img src="assets/icons/meno.svg">
                                                                                </button>
                                                                            </span>
                                                                            <input type="text" name="quantity"
                                                                                class="form-control input-number quantity"
                                                                                [value]="elCart.qty" disabled>
                                                                            <span class="input-group-prepend">
                                                                                <button type="button" class="btn"
                                                                                    data-type="plus"
                                                                                    (click)="addToCartSlave(elCart, slave.order_id)">
                                                                                    <img src="assets/icons/aggiungi.svg">
                                                                                </button>
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        </ng-container>
                                                    </ng-container>
                                                </tbody>
                                            </table>
                                            <app-separator></app-separator>
                                        </div>
                                    </ng-container>
                                </ng-container>
                            </ng-container>
                        </div>
                    </div>
                    <div class="col-xl-6 col-sm-12 col-12">
                        <app-cart-box [editable]="false" [loader]="false" [showCoupon]="false" [showProducts]="false">
                        </app-cart-box>
                    </div>
                    <!--div class="col-lg-4 col-sm-12 col-xs-12 d-sm-block" *ngIf="cartData.order.type_order==typeOrder.REST_ASPORTO">
                        <app-carttakeaway-box [editable]="false" [loader]="false" [showCoupon]="false" [showProducts]="false">
                        </app-carttakeaway-box>
                    </div-->
                </div>
            </div>
            <div class="col-12 d-block d-md-none" *ngIf="cartData && cartData.count>0">
                <app-cart-box [editable]="false" [loader]="false" [showCoupon]="false" [showProducts]="true" [restaurant]="restaurant">
                </app-cart-box>
            </div>
        </div>
    </div>
</section>

<!--div class="mobile-fix-option d-block d-sm-none mobile-footer-fixed" *ngIf="cartData && cartData.count>0">
    <a class="btn btn-solid btn-block btn-green mx-auto mt-0 text-center"
        *ngIf="cartData != null && cartData.order.euro_total > 0" disabled="cartData.order.items.length == 0"
        (click)="goToCheckout()">Vai alla cassa</a> 
</div-->

<app-footer-two [class]="'bg-img-gym bg-size'"></app-footer-two>